/* CUSTOMERS */
export const GET_CUSTOMERS = "GET_CUSTOMERS"
export const GET_CUSTOMERS_SUCCESS = "GET_CUSTOMERS_SUCCESS"
export const GET_CUSTOMERS_FAIL = "GET_CUSTOMERS_FAIL"


/* GET_CUSTOMER_DETAIL */
export const GET_CUSTOMER_DETAIL = "GET_CUSTOMER_DETAIL"
export const GET_CUSTOMER_DETAIL_SUCCESS = "GET_CUSTOMER_DETAIL_SUCCESS"
export const GET_CUSTOMER_DETAIL_FAIL = "GET_CUSTOMER_DETAIL_FAIL"

/*  */
export const GET_AUTH_USER = "GET_AUTH_USER"
export const GET_AUTH_USER_FAIL = "GET_AUTH_USER_FAIL"
export const GET_AUTH_USER_SUCCESS = "GET_AUTH_USER_SUCCESS"

/**
 * add CUSTOMER
 */
 export const ADD_NEW_CUSTOMER = "ADD_NEW_CUSTOMER"
 export const ADD_CUSTOMER_SUCCESS = "ADD_CUSTOMER_SUCCESS"
 export const ADD_CUSTOMER_FAIL = "ADD_CUSTOMER_FAIL"
 
 /**
  * Edit CUSTOMER
  */
 export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER"
 export const UPDATE_CUSTOMER_FIELD = "UPDATE_CUSTOMER_FIELD"
 export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS"
 export const UPDATE_CUSTOMER_FAIL = "UPDATE_CUSTOMER_FAIL"
 
 /**
  * Delete CUSTOMER
  */
 export const DELETE_CUSTOMER = "DELETE_CUSTOMER"
 export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS"
 export const DELETE_CUSTOMER_FAIL = "DELETE_CUSTOMER_FAIL"
 

